import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'core/common/i18n'
import Modal from 'core/components/Modal'
import { StyledComponent, StyledImg } from './style'

const ProductImageModal = ({ handleClose, handleConfirm, imageLink, isOpen }) => {
  return (
    <Modal
      aria-labelledby="customized-dialog-title"
      fullWidth
      maxWidth="sm"
      onCancel={handleClose}
      onConfirm={handleConfirm}
      open={isOpen}
      textCancel={i18n.t('product.productUpload.close')}
      textConfirm={i18n.t('product.productUpload.addToGalery')}
      title={i18n.t('product.productUpload.imageModalTitle')}
    >
      <StyledComponent>
        <StyledImg alt={i18n.t('product.productUpload.altImage')} src={imageLink} frameBorder="0" />
      </StyledComponent>
    </Modal>
  )
}

ProductImageModal.propTypes = {
  handleClose: PropTypes.func.isRequired,
  handleConfirm: PropTypes.func.isRequired,
  imageLink: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
}

export default ProductImageModal
